module.exports = __webpack_public_path__ + "562debf350e384a5219db70fe289a740.png";


//////////////////
// WEBPACK FOOTER
// ./app/components/Footer2/Testimonials/adidas.png
// module id = 562
// module chunks = 16